import styled from "@emotion/styled/macro";
import { colors } from "../../../../../common/styles/theme.styles";

export const SectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background: #F7F8F9;
    border: 1px solid ${colors.gray3};
    border-radius: 12px;
    transition: border-color 0.2s ease;

    &:hover {
        border-color: ${colors.darkGray2};
    }
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fff;
    cursor: pointer;
    
    ${props => props.isOpen &&
        `background-color: #F7F8F9;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid ${colors.gray3};`
    };
`;

export const SectionHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SectionHeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    
    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SectionTitle = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: ${colors.darkGray1};
`;

export const TagCount = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 12px;
    line-height: 1.265;
    color: ${colors.darkGray1};
`;

export const ArrowIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease;
    
    ${props => props.isOpen && 'transform: rotate(180deg);'}
    
    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SectionContent = styled.div`
    background: #fff;
    border-radius: 0 0 12px 12px;
    padding: 16px;
`;



export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

// Modal styles
export const PeriodModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
`;

export const PeriodModalContent = styled.div`
    position: relative;
    max-width: 400px;
    width: 90%;
    max-height: 90vh;
    overflow: auto;
`;

export const PeriodModal = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

export const PeriodModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid ${colors.gray3};
`;

export const PeriodModalTitle = styled.h3`
    font-family: Circular;
    font-weight: 500;
    font-size: 18px;
    color: ${colors.darkGray1};
    margin: 0;
`;

export const PeriodModalClose = styled.button`
    background: none;
    border: none;
    font-size: 24px;
    color: ${colors.darkGray2};
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        color: ${colors.darkGray1};
    }
`;

export const PeriodModalBody = styled.div`
    padding: 24px;
`;

export const YearSelector = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    margin-bottom: 24px;
`;

export const YearArrow = styled.button`
    background: none;
    border: none;
    font-size: 20px;
    color: ${colors.darkGray1};
    cursor: pointer;
    padding: 8px;
    
    &:hover {
        background: #F7F8F9;
        border-radius: 4px;
    }
`;

export const YearDisplay = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 20px;
    color: ${colors.darkGray1};
    min-width: 60px;
    text-align: center;
`;

export const QuarterSelector = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

export const QuarterOption = styled.button`
    flex: 1;
    min-width: 60px;
    padding: 12px 16px;
    border: 1px solid ${colors.gray3};
    background: ${props => props.isSelected ? colors.darkGray1 : 'white'};
    color: ${props => props.isSelected ? 'white' : colors.darkGray1};
    border-radius: 8px;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: ${colors.darkGray2};
        ${props => !props.isSelected && `background: #F7F8F9;`}
    }
`;

export const PeriodModalFooter = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    padding: 20px 24px;
    border-top: 1px solid ${colors.gray3};
`;

export const PeriodModalButton = styled.button`
    padding: 10px 20px;
    border-radius: 8px;
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    ${props => props.variant === 'primary' ? `
        background: ${colors.darkGray1};
        color: white;
        border: 1px solid ${colors.darkGray1};
        
        &:hover {
            background: ${colors.darkGray2};
        }
    ` : `
        background: white;
        color: ${colors.darkGray1};
        border: 1px solid ${colors.gray3};
        
        &:hover {
            background: #F7F8F9;
        }
    `}
`;

 